namespace $.$$ {

	$mol_style_define( $bog_gamengine_demo_crumb2, {

		Draw: {
			flex: {
				grow: 1,
			},
			minHeight: '16rem',
		},

		End: {
			position: 'absolute',
			inset: '0',
			margin: 'auto',
			width: 'max-content',
			height: 'max-content',
		},

	} )

}
